import React from 'react'
import type { Nil } from '@pbt/pbt-ui-components'

import type { LabTestDashboardOrder, LabTestDashboardTest } from '~/types'

import LabOrderStatusLabel, {
  type LabOrderStatusLabelProps,
} from './LabOrderStatusLabel'
import LabTestsStatusLabel from './LabTestsStatusLabel'

export interface LabStatusLabelProps
  extends Omit<LabOrderStatusLabelProps, 'order' | 'stateId'> {
  order: LabTestDashboardOrder | Nil
  tests: LabTestDashboardTest[]
}

const LabStatusLabel = ({ order, tests, ...rest }: LabStatusLabelProps) =>
  order ? (
    <LabOrderStatusLabel stateId={order.statusId} {...rest} />
  ) : (
    <LabTestsStatusLabel tests={tests} {...rest} />
  )

export default LabStatusLabel
